import React from 'react';
import styled from 'styled-components';
import SubTitle from './SubTitle';

const PageTitle = styled.h1`
    font-size: 32px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.41;
    letter-spacing: normal;
    text-align: left;
    color: ${(props) => props.color || props.theme.colors.greyishBrown};
`;

const Title = ({ children }) => {
    return (
        <>
            <PageTitle>{children}</PageTitle>
        </>
    );
};

export default Title;

export { Title, SubTitle };
